var styles = {
  "Container": "_Container_195be_1",
  "Title": "_Title_195be_9",
  "Content": "_Content_195be_16",
  "Link": "_Link_195be_22"
};

export { styles as default };
